import React, { useRef, useState } from 'react';
import Cropper from 'react-easy-crop';
import { useTranslation } from 'react-i18next';
import ManageModal from 'shared/components/modals/ManageModal';
import { generateDownload } from './utils';
import { API, Storage, graphqlOperation, Auth } from 'aws-amplify';
import { uploadProfilePicture } from 'graphql/user/mutations';
import { useAlert } from 'react-alert';
import { getError } from 'utils/appHelpers';

const AvatarSelectionModal = ({ onClose, onSuccess, file }) => {
  const alert = useAlert();
  const image = useRef(URL.createObjectURL(file));
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [fetching, setFetching] = useState(false);
  const croppedAreaPixels = useRef();
  const { t } = useTranslation();

  const onCropChange = crop => {
    setCrop(crop);
  };

  const onZoomChange = zoom => {
    setZoom(zoom);
  };

  const onFormSubmit = async () => {
    try {
      setFetching(true);
      const name = `${Date.now()}_${file.name}`.replace(/[^a-zA-Z0-9]/g, '');
      const blob = await generateDownload(image.current, croppedAreaPixels.current);
      const credentials = await Auth.currentCredentials();
      const data = await Storage.put(name, blob, { level: 'private', contentType: 'image/png' });
      await API.graphql(
        graphqlOperation(uploadProfilePicture, { uploadedData: { key: `${credentials.identityId}/${data.key}` } }),
      );
      onSuccess && onSuccess();
      onClose();
    } catch (err) {
      alert.error(getError(err));
    } finally {
      setFetching(false);
    }
  };

  const onCropComplete = (croppedArea, croppedAreapx) => {
    croppedAreaPixels.current = croppedAreapx;
  };

  const onMediaLoaded = sizes => {
    setZoom(sizes.naturalHeight / 600);
  };

  return (
    <ManageModal
      title={t('avatar_modal_title')}
      sumbitButton={t('btn_upload_avatar')}
      onCloseModal={onClose}
      onSubmit={onFormSubmit}
      isButtonDisabled={fetching}
      showLoadingButton={true}
      className='large-modal avatar-selection-modal'
    >
      <div className='row pb-5'>
        <div className='crop-container'>
          <Cropper
            image={image.current}
            crop={crop}
            zoom={zoom}
            aspect={1}
            cropShape='round'
            showGrid={false}
            onCropChange={onCropChange}
            onCropComplete={onCropComplete}
            onZoomChange={onZoomChange}
            onMediaLoaded={onMediaLoaded}
          />
        </div>
        <div className='controls mt-10 w-100 px-10 px-md-0'>
          <input
            type='range'
            className='form-control'
            value={zoom}
            min={1}
            max={4}
            step={0.1}
            disabled={fetching}
            onChange={e => onZoomChange(e.target.value)}
          />
        </div>
      </div>
    </ManageModal>
  );
};

export default AvatarSelectionModal;
